function normalizePathname(pathname: string): string {
  const normalized = pathname.replace(/\/+$/, "");
  return normalized || "/";
}

export function matchesConfiguredPlayerUrl(
  configuredPlayerUrl: string | null,
  currentUrl: string,
): boolean {
  if (!configuredPlayerUrl) return false;
  try {
    const configured = new URL(configuredPlayerUrl);
    const current = new URL(currentUrl);
    return (
      configured.origin === current.origin &&
      normalizePathname(configured.pathname) === normalizePathname(current.pathname) &&
      configured.search === current.search &&
      configured.hash === current.hash
    );
  } catch {
    return false;
  }
}
